export default function DashboardSection({ title, children }) {
  return (
    <div className="section">
      <div className="section-head">
        <h3>{title}</h3>
      </div>
      {children}
    </div>
  );
}
